module.exports = require('./helpers/bundle-url').getBundleURL('iX4Xl') + "jira.304a1bac.png";